





























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'BaseIfpFilter',

  props: {
    label: {
      type: String,
      default: '',
    },
    labelIcon: {
      type: String,
      default: '',
    },
    /* Able to clear value (but not remove the filter) */
    clearable: {
      type: Boolean,
      default: false,
    },
    /* Able to clear/remove in one click */
    removable: {
      type: Boolean,
      default: false,
    },
    optionless: {
      type: Boolean,
      default: false,
    },
    /* By default, filter will emphasize if value display slot has data. 
    You can disable that here and then use the 'emphasize' prop solely to control emphasis */
    disableValueDisplayEmphasis: {
      type: Boolean,
      default: false,
    },
    /* Emphasizes filter */
    emphasize: {
      type: Boolean,
      default: false,
    },
    clearBackground: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // TO DO
    }
  },

  computed: {
    hasValueDisplay(): boolean {
      const slotHydrated: boolean = !!this.$slots['value-display']

      const slotHasText: boolean =
        slotHydrated &&
        (this.$slots['value-display'][0].text !== undefined &&
          this.$slots['value-display'][0].text !== null &&
          this.$slots['value-display'][0].text.trim().length > 0)

      const slotHasOtherVal: boolean =
        slotHydrated &&
        (this.$slots['value-display'][0].tag !== undefined &&
          this.$slots['value-display'][0].tag !== null)

      return slotHydrated && (slotHasText || slotHasOtherVal)
    },
  },

  methods: {
    // TO DO
  },
})
